<!-- Background Gallery -->
<div class="background">
  <eng-sliding-gallery></eng-sliding-gallery>
</div>
<div class="background background-shade"></div>

<!-- Main Content -->
<div class="content-wrapper">
  <div class="centered">
    <div class="block text-center hero">
      <img class="herologo" src="/Logo_Full_White.png" alt="Luminary" />
      <!-- <div class="line upper heroline1">Luminary</div> -->
      <div class="line upper heroline2">Engage</div>
      <div class="line upper heroline3">Visualisation and Content Portal</div>
      <button type="button" class="btn btn-primary btn-lg mt-2 herobutton" (click)="onGetStarted()">Get Started</button>
    </div>
  </div>
</div>
